import {castArray, iteratee, sortBy} from 'lodash';
import React, {useMemo} from 'react';
import {useI18n} from '../../../../data/hooks/i18nHooks';
import ParticipantsList from '../ParticipantsList';

// Same thresholds as the mobile app
const BEST_MATCH_THRESHOLD = 0.98,
    OTHER_MATCH_THRESHOLD = 0.01;

// Highest fitness first; ties are broken by the participant's own sort key(s)
function sortMatches(matches, sortByIterator) {
    const participantKeys = sortByIterator ? castArray(sortByIterator) : [],
        byParticipantKey = participantKeys.map(key => match => iteratee(key)(match.participant));

    return sortBy(matches, [match => -match.fitness, ...byParticipantKey]);
}

function PartialMatchesList(props) {
    const {className = '', list: matchesList, sortBy: sortByIterator = 'sortstring', busy} = props,
        i18n = useI18n(),
        list = useMemo(() => {
            const sorted = sortMatches(matchesList, sortByIterator),
                full = [],
                partial = [];

            for (let {fitness, participant} of sorted) {
                if (fitness > BEST_MATCH_THRESHOLD) {
                    full.push(participant);
                } else if (fitness >= OTHER_MATCH_THRESHOLD) {
                    partial.push(participant);
                }
            }

            const list = [];

            if (full.length) {
                list.push({
                    title: i18n['label.recommended.best'],
                    items: full,
                });
            }

            if (partial.length) {
                list.push({
                    title: i18n['label.recommended.other'],
                    items: partial,
                });
            }

            return list;
        }, [matchesList, sortByIterator]);

    return <ParticipantsList className={className} list={list} busy={busy} />;
}

export default PartialMatchesList;
